import React, { Children } from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function FailedApproaches() {
  const approaches = [{
    title: 'Dietas de 1,200 calorías',
    desc: "Envían una señal de 'hambruna' a tu cerebro, obligándolo a guardar cada gramo de grasa."
  }, {
    title: 'Cardio excesivo',
    desc: 'Eleva el cortisol, la hormona del estrés que deposita grasa directamente en tu cintura.'
  }, {
    title: "Suplementos 'quemagrasas'",
    desc: 'Solo estresan tu corazón y sistema nervioso sin atacar la raíz del problema celular.'
  }, {
    title: 'Eliminar carbohidratos',
    desc: 'Apaga tu tiroides por completo, el verdadero motor de tu energía diaria.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-20 bg-white" data-id="element-17">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="mb-12 text-3xl font-bold text-center text-gray-900 md:text-4xl" data-id="element-20">
            Por qué lo que has intentado no funciona
          </h2>
        </FadeIn>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-21">
          {approaches.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-6 bg-red-50/30 rounded-2xl border border-red-100" data-id="element-22">
              <div className="flex-shrink-0 mt-1 mr-4" data-id="element-23">
                <div className="flex items-center justify-center w-8 h-8 bg-red-100 rounded-full" data-id="element-24">
                  <svg className="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-25">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-26" />
                  </svg>
                </div>
              </div>
              <div data-id="element-27">
                <h3 className="mb-2 text-xl font-bold text-gray-900" data-id="element-28">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-29">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}